import { render, staticRenderFns } from "./SitioIndex.vue?vue&type=template&id=0640499f"
import script from "./SitioIndex.vue?vue&type=script&lang=js"
export * from "./SitioIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports